import React from 'react';
import { MBText } from '@shared/components/text';
import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { MBBaseChatBanner } from './base';

interface MBDMChatBannerProps {
  user: MBAPI.ShortUser;
  channel: MBAPI.ChannelChatThread;
}

export function MBDMChatBanner({ user, channel }: MBDMChatBannerProps) {
  return (
    <MBBaseChatBanner title={user.fullName} subtitle={`@${user.username}`} channel={channel}>
      <MBText color={Colors.v2.greenSecondary90}>
        {i18n('chat.banner.dm', { name: user.fullName })}
      </MBText>
    </MBBaseChatBanner>
  );
}
